import PropTypes from 'prop-types';
import cn from "classnames";
import style from "./outOfStock.module.scss";
import Cross from "../../../../../assets/images/Fireboard/CrossCircle";
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const CartItems = (props) => {
    const { selectedTab, cartItems, setCartItems, invokeItemStatusUpdateApi } = props;

    const onDeleteItem = (itemToDelete) => {
        const updatedItems = cartItems.filter(item => item.id !== itemToDelete.id);
        setCartItems(updatedItems);
    };
    return (
        <div className="h-100 d-flex flex-column">
            <div className="pb-3 fw-500">{selectedTab === 'items' ? FLABEL().OOS_SELECTED_ITEMS : FLABEL().OOS_SELECTED_MODIFIERS}</div>
            {cartItems && cartItems.length > 0 ? (
                <div className={style.itemsContainer}>
                    {cartItems.map(item => (
                        <div
                            key={`searchItem-${item.id}`}
                            className={cn(style.searchItem, 'position-relative')}
                        >
                            <div className={cn(style.deleteIcon)} onClick={() => onDeleteItem(item)}>
                                <Cross />
                            </div>
                            <div className={cn(style.posId, 'text-center')}>{item.posId}</div>
                            <div className="text-center pt-1 text-truncate">
                                {item.name}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className={cn(style.itemsContainer, 'd-flex justify-content-center align-items-center')}>
                    <div className={cn('d-flex justify-content-center align-items-center text-center w-100', style.notFound)}>{selectedTab === 'items' ? FLABEL().OOS_NO_ITEMS : FLABEL().OOS_NO_MODIFIERS }</div>
                </div>
            )}

            <div className="d-flex gap-2 pt-2">
                <div className="col-12 px-0 d-flex ">
                    <div className="col-6 pl-0 pr-1"><button className={cn(style.Secondarybtn, 'col-12 fw-500')} disabled={cartItems.length === 0} onClick={() => setCartItems([])}>{FLABEL().OOS_CLEAR_ALL}</button></div>
                    <div className="col-6 pr-0 pl-2"><button className={cn(style.primaryBtn, 'col-12 fw-500')} disabled={cartItems.length === 0} onClick={() => invokeItemStatusUpdateApi(true)} >{FLABEL().OOS_MARK_OUT_OF_STOCK}</button></div>
                </div>
            </div>
        </div>
    )
}

CartItems.propTypes = {
  selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  cartItems: PropTypes.array.isRequired,
  setCartItems: PropTypes.func.isRequired,
  invokeItemStatusUpdateApi: PropTypes.func.isRequired,
};

export default CartItems;